;(function () {
  /* jshint validthis: true */
  'use strict'

  angular
    .module('deskfy.arts')
    .factory('PlaceholderElementsService', placeholderElementsService)

  /* @ngInject */
  function placeholderElementsService ($q) {
    // For now we are using an static array of shapes
    // in the future it will come from the backend
    this.aShapes = [
      {
        name: 'quadrado',
        imgSrc: '/assets/img/components/elements/basicShapes/square.png',
        filePath: '/assets/shapes/basicShapes/square.svg',
        width: 80
      },
      {
        name: 'quadrado arredondado',
        imgSrc: '/assets/img/components/elements/basicShapes/square-rounded.png',
        filePath: '/assets/shapes/basicShapes/square-rounded.svg',
        width: 80
      },
      {
        name: 'retangulo',
        imgSrc: '/assets/img/components/elements/basicShapes/retangulo.png',
        filePath: '/assets/shapes/basicShapes/retangulo.svg',
        width: 80
      },
      {
        name: 'retangulo-2',
        imgSrc: '/assets/img/components/elements/basicShapes/retangulo-2.png',
        filePath: '/assets/shapes/basicShapes/retangulo-2.svg',
        width: 80
      },
      {
        name: 'triangulo',
        imgSrc: '/assets/img/components/elements/basicShapes/triangle.png',
        filePath: '/assets/shapes/basicShapes/triangle.svg',
        width: 80
      },
      {
        name: 'estrela',
        imgSrc: '/assets/img/components/elements/basicShapes/star.png',
        filePath: '/assets/shapes/basicShapes/star.svg',
        width: 80
      },
      {
        name: 'poligono',
        imgSrc: '/assets/img/components/elements/basicShapes/polygon.png',
        filePath: '/assets/shapes/basicShapes/polygon.svg',
        width: 80
      },
      {
        name: 'circulo',
        imgSrc: '/assets/img/components/elements/basicShapes/circle.png',
        filePath: '/assets/shapes/basicShapes/circle.svg',
        width: 80
      },
      {
        name: 'retangulo-customizado',
        imgSrc: '/assets/img/components/elements/basicShapes/custom-rect.png',
        filePath: '/assets/shapes/basicShapes/custom-rect.svg',
        width: 80
      }
    ]

    this.fnSetShapes = function (aShapes) {
      this.aShapes = aShapes
    }

    this.fnGetShapes = function () {
      // from now we are returning static data
      // in the future we should get the data from server
      // and return a Promise
      return $q.resolve(this.aShapes)
    }

    return this
  }
})()
